export default "/images/socialmedia_facebook.png?95dd14e5e2358634b52fa8ac6a9ecff4";